import { render, staticRenderFns } from "./RecMaterial.vue?vue&type=template&id=30d55e01&scoped=true"
import script from "./RecMaterial.vue?vue&type=script&lang=js"
export * from "./RecMaterial.vue?vue&type=script&lang=js"
import style0 from "./RecMaterial.vue?vue&type=style&index=0&id=30d55e01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d55e01",
  null
  
)

export default component.exports